import { useCallback } from 'react';
import { createContext, ReactNode, useContext, useState } from 'react';

import { Prescription } from '~/models/Sequencies';

type PrescriptionData = {
  prescription: Prescription;
  updatePrescription: (value: Prescription) => void;
};

export const PrescriptionContext = createContext({} as PrescriptionData);

type Props = {
  children: ReactNode;
};

export const PrescriptionProvider = ({ children }: Props) => {
  const [prescription, setPrescription] = useState<Prescription>(
    {} as Prescription,
  );

  const updatePrescription = useCallback((value: Prescription) => {
    setPrescription(value);
  }, []);

  return (
    <PrescriptionContext.Provider
      value={{
        prescription,
        updatePrescription,
      }}
    >
      {children}
    </PrescriptionContext.Provider>
  );
};

export const usePrescription = (): PrescriptionData => {
  const context = useContext(PrescriptionContext);

  if (!context)
    throw new Error(
      `usePrescription must be use within a PrescriptionProvider!`,
    );

  return context;
};
